export default __webpack_public_path__ + "static/media/vendor_logo.de82a9c1.svg";